<template>
  <div class="empty">
    <!-- 图片 -->
    <img class="img" :src="imgUrl" />
    <div v-if="title" class="title">{{ title }}</div>
    <!-- 描述 -->
    <div v-if="type === 1" class="desc">
      {{ desc || '空空如也' }}
    </div>
    <div v-if="type === 2" class="desc">
      {{ desc || '获取数据失败，请重试' }}
    </div>
    <div v-if="type === 3" class="desc">
      {{ desc || '网络异常，请检查您的网络设置' }}
    </div>
    <div v-if="type === 4" class="desc">
      {{ desc || '您还没有登录哦' }}
    </div>

    <!-- 按钮 -->
    <template v-if="hasBtn">
      <div v-if="type === 1" class="btn" @click="clickBtn">
        {{ btnText || '刷新' }}
      </div>
      <div v-if="type === 2" class="btn" @click="clickBtn">
        {{ btnText || '点击重试' }}
      </div>
      <div v-if="type === 3" class="btn" @click="clickBtn">
        {{ btnText || '点击重试' }}
      </div>
      <div v-if="type === 4" class="btn" @click="clickBtn">
        {{ btnText || '去登录' }}
      </div>
    </template>
  </div>
</template>

<script>
import { EmptyImage } from './enum'
export default {
  name: 'Empty',
  props: {
    type: {
      type: Number,
      default: 1
    },
    desc: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    hasBtn: {
      type: Boolean,
      default: false
    },
    btnText: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: 'Empty'
    }
  },
  data() {
    return {}
  },
  computed: {
    imgUrl() {
      return this.img && EmptyImage[this.img]
        ? EmptyImage[this.img]
        : EmptyImage.Empty
    }
  },
  methods: {
    clickBtn() {
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$emit('clickBtn')
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variable.scss';
@import '@/styles/mixin.scss';
.empty {
  display: flex;

  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  flex-direction: column;
  justify-content: center;
  align-items: center;

  .img {
    width: 2.4rem;

    flex: none;
    margin-bottom: 0.6rem;
  }
  .title {
    margin-bottom: 0.2rem /* 10/50 */;

    font-size: 0.32rem;
    color: $c-text-content-light;
  }
  .desc {
    font-size: 0.28rem;
    color: $c-text-content-light;
  }
  .btn {
    width: 2.32rem;
    height: 0.8rem;
    margin-top: 0.6rem;

    background-color: #ffffff;
    border-radius: 0.4rem;
    border: 0.02rem solid $theme-main;

    font-size: 0.32rem;
    text-align: center;
    color: $theme-main;
    box-sizing: border-box;
    @include flex-column-center;
  }
}
// .empty.absolute {
//   position: absolute;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   left: 0;
// }
</style>
